import React from "react";
import styled from "styled-components";
import { ClipLoader } from "react-spinners";

const Button = styled.button`
  border: 0;
  border-radius: 5px;
  background-color: ${(props) => props.theme.mainColor};
  width: 100%;
  color: white;
  padding: 10px;
  :hover {
    opacity: 0.5;
  }
  :focus {
    outline: none;
  }
`;

const BlockButton = styled(Button)`
  width: 100%;
`;

const DefaultButton = ({
  style = {},
  onClick = () => null,
  text = "null",
  type = "button",
  lock = false,
  disabled = false,
  block = false,
}) => {
  return block ? (
    <BlockButton style={style} onClick={disabled ? () => null : onClick} type={type}>
      {disabled ? <ClipLoader sizeUnit={"px"} size={15} color={"white"} /> : text}
    </BlockButton>
  ) : (
    <Button style={style} onClick={disabled ? () => null : onClick} type={type}>
      {disabled ? <ClipLoader sizeUnit={"px"} size={15} color={"white"} /> : text}
    </Button>
  );
};

export default DefaultButton;
